import { render, staticRenderFns } from "./terminate-case-modal.vue?vue&type=template&id=4c9e6564&"
import script from "./terminate-case-modal.vue?vue&type=script&lang=js&"
export * from "./terminate-case-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports